module.exports = __webpack_public_path__ + "static/media/univers-linge.22d1ad4d.png";